module.exports = __webpack_public_path__ + "media/5.055011c6.wav";